export const ERROR_TITLE = "Oops…something went wrong!";
export const ERROR_SUBTITLE =
  "Check to see if you are connected to a network right now or try reloading.";
export const RELOAD = "Reload";
export const SEARCH_AGAIN = "Search Again";
